import _ from 'lodash'
export function formatIndianCurrency(amount) {
    // Convert the amount to a string
    const amountStr = amount.toString();

    // Split the amount into rupees and paise (if any)
    const [rupees, paise] = amountStr.split('.');

    // Add commas to the rupees part
    const formattedRupees = rupees.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Combine the formatted rupees and paise (if any)
    const formattedAmount = paise ? `₹${formattedRupees}.${paise}` : `₹${formattedRupees}`;

    return formattedAmount;
}
export function formatMoney(n) {
    return "₹" + (Math.ceil(parseInt(n) * 100) / 100).toLocaleString();
}

export function percentage(mrp,price){
    return Math.ceil(((parseInt(mrp)-parseInt(price))/parseInt(mrp))*100)
}

export const renderName = (details)=>{
    let name = details.name
    _.map(details.variations.options,(value,key)=>{
        if(key!=="_id" && key!=="mrp" && key!=="price" && key!=="imgs"){
            name = name + " " + `(${value})`
        }
    })
    return name
}
export const renderName2 = (product,options)=>{
    let name = product.name
    _.map(options,(value,key)=>{
        if(key!=="_id" && key!=="mrp" && key!=="price" && key!=="imgs"){
            name = name + " " + `(${value})`
        }
    })
    return name
}
export const cartTotal = (cart)=>{
    let total = 0
    cart.map(item=>{
        total = total + (parseInt(item.variations.item.options.price) * item.variations.quantity)
    })
    return formatMoney(total);
}

export const cartMrpTotal = (cart)=>{
    let total = 0
    cart.map(item=>{
        total = total + (parseInt(item.variations.item.options.mrp) * item.variations.quantity)
    })
    return formatMoney(total);
}

export const cartDiscountTotal = (cart)=>{
    let total = 0
    let mrptotal = 0
    cart.map(item=>{
        total = total + (parseInt(item.variations.item.options.price)* item.variations.quantity)
    })
    cart.map(item=>{
        mrptotal = mrptotal + (parseInt(item.variations.item.options.mrp)* item.variations.quantity)
    })
    return formatMoney(mrptotal-total);
}

export const cartDiscountPercantage = (cart)=>{
    let total = 0
    let mrptotal = 0
    cart.map(item=>{
        total = total + (parseInt(item.variations.item.options.price) * item.variations.quantity)
    })
    cart.map(item=>{
        mrptotal = mrptotal + (parseInt(item.variations.item.options.mrp)* item.variations.quantity)
    })
    return percentage(mrptotal,total);
}


export const orderSubTotal = (items)=>{
    let subTotal = 0;
    items.map(item=>{
        subTotal =subTotal + item.quantity * parseInt(item.details.options.mrp)
    })
    return formatMoney(subTotal)
}

export const orderTotal = (items)=>{
    let total = 0;
    items.map(item=>{
        total =total + item.quantity * parseInt(item.details.options.price)
    })
    return formatMoney(total)
}

export const orderDiscount = (items)=>{
    let total = 0;
    let subTotal = 0
    items.map(item=>{
        total =total + item.quantity * parseInt(item.details.options.price)
        subTotal =subTotal + item.quantity * parseInt(item.details.options.mrp)
    })
    return formatMoney(subTotal - total)
}

export const renderPriceWithoutGst = (price,gst)=>{
    let gstamount = (price/100)*gst
    return formatMoney(price-gstamount)
}

export const renderTenure = (sr,price)=>{
    if(sr===1 || sr==="1" || sr==="3by0"){
        return {name:"3by0",months:3,downPayment:0,monthsEmi:Math.ceil(price/3),string:`3 Months No Cost + ₹0 Down Payment EMI by CleverPe`}
    }else if(sr===2 || sr==="2" || sr==="6by0"){
        return {name:"6by0",months:6,downPayment:0,monthsEmi:Math.ceil(price/6),string:`6 Months No Cost + ₹0 Down Payment EMI by CleverPe`}
    }else if(sr===3 || sr==="3" || sr==="8by2"){
        return {name:"8by2",months:6,downPayment:Math.ceil((price/8)*2),monthsEmi:Math.ceil(price/8),string:`6 Months No Cost + ₹${Math.ceil((price/8)*2)} Down Payment EMI by CleverPe`}
    }
    else if(sr===4 || sr==="4" || sr==="9by3"){
        return {name:"9by3",months:6,downPayment:Math.ceil((price/9)*3),monthsEmi:Math.ceil(price/9),string:`6 Months No Cost + ₹${Math.ceil((price/9)*3)} Down Payment EMI by CleverPe`}
    }
    else if(sr===5 || sr==="5" || sr==="9by0"){
        return {name:"9by0",months:9,downPayment:0,monthsEmi:Math.ceil(price/9),string:`9 Months No Cost + ₹0 Down Payment EMI by CleverPe`}
    }else if(sr===6 || sr==="6" || sr==="12by0"){
        return {name:"12by0",months:12,downPayment:0,monthsEmi:Math.ceil(price/12),string:`12 Months No Cost + ₹0 Down Payment EMI by CleverPe`}
    }
}

export const renderTenureInterest = (sr,price)=>{
    if(sr===1 || sr==="1" || sr==="3by0"){
        return {name:"3by0",months:3,downPayment:0,monthsEmi:Math.ceil(price/3),interest:Math.round((((price*16)/100)/12)*3),string:`3 Month Low Cost EMIs (Total Interest Payable ₹${Math.round((((price*16)/100)/12)*3)}) + ₹0 Down Payment`}
    }else if(sr===2 || sr==="2" || sr==="6by0"){
        return {name:"6by0",months:6,downPayment:0,monthsEmi:Math.ceil(price/6),interest:Math.round((((price*15)/100)/12)*6),string:`6 Month Low Cost EMIs (Total Interest Payable ₹${Math.round((((price*15)/100)/12)*6)}) + ₹0 Down Payment`}
    }else if(sr===3 || sr==="3" || sr==="8by2"){
        return {name:"8by2",months:6,downPayment:Math.ceil((price/9)*3),monthsEmi:Math.ceil(price/8),interest:Math.round((((price*15)/100)/12)*6),string:`6 Month Low Cost EMIs (Total Interest Payable ₹${Math.round(((((price-Math.ceil((price/9)*3))*15)/100)/12)*6)}) + ₹${Math.ceil((price/9)*3)} Down Payment`}
    }
    else if(sr===4 || sr==="4" || sr==="9by3"){
        return {name:"9by3",months:6,downPayment:Math.ceil((price/8)*2),monthsEmi:Math.ceil(price/9),interest:Math.round((((price*15)/100)/12)*6),string:`6 Month Low Cost EMIs (Total Interest Payable ₹${Math.round(((((price-Math.ceil((price/8)*2))*15)/100)/12)*6)}) + ₹${Math.ceil((price/8)*2)} Down Payment`}
    }else if(sr===5 || sr==="5" || sr==="9by0"){
        return {name:"9by0",months:9,downPayment:0,monthsEmi:Math.ceil(price/9),interest:Math.round((((price*14.66667)/100)/12)*9),string:`9 Month Low Cost EMIs (Total Interest Payable ₹${Math.round((((price*15)/100)/12)*6)}) + ₹0 Down Payment`}
    }else if(sr===6 || sr==="6" || sr==="12by0"){
        return {name:"12by0",months:12,downPayment:0,monthsEmi:Math.ceil(price/12),interest:Math.round((((price*14.5)/100)/12)*12),string:`12 Month Low Cost EMIs (Total Interest Payable ₹${Math.round((((price*15)/100)/12)*6)}) + ₹0 Down Payment`}
    }
}

export const renderTenureString = (sr,price)=>{
    if(sr===1 || sr==="1" || sr==="3by0"){
        return `3 Months No Cost + ₹0 Down Payment EMI by CleverPe`
    }else if(sr===2 || sr==="2" || sr==="6by0"){
        return `6 Months No Cost + ₹0 Down Payment EMI by CleverPe`
    }else if(sr===3 || sr==="3" || sr==="8by2"){
        return `6 Months No Cost + ₹${Math.ceil((price/8)*2)} Down Payment EMI by CleverPe`
    }
    else if(sr===4 || sr==="4" || sr==="9by3"){
        return `6 Months No Cost + ₹${Math.ceil((price/9)*3)} Down Payment EMI by CleverPe`
    }
    else if(sr===5 || sr==="5" || sr==="9by0"){
        return `9 Months No Cost + ₹0 Down Payment EMI by CleverPe`
    }else if(sr===6 || sr==="6" || sr==="12by0"){
        return `12 Months No Cost + ₹0 Down Payment EMI by CleverPe`
    }
}

export const renderTenureStringInterest = (sr,price)=>{
    if(sr===1 || sr==="1" || sr==="3by0"){
        return `3 Month Low Cost EMIs (Total Interest Payable ₹${Math.round((((price*16)/100)/12)*3)}) + ₹0 Down Payment`
    }else if(sr===2 || sr==="2" || sr==="6by0"){
        return `6 Month Low Cost EMIs (Total Interest Payable ₹${Math.round((((price*15)/100)/12)*6)}) + ₹0 Down Payment`
    }else if(sr===3 || sr==="3" || sr==="8by2"){
        return `6 Month Low Cost EMIs (Total Interest Payable ₹${Math.round(((((price-Math.ceil((price/9)*3))*15)/100)/12)*6)}) + ₹${Math.ceil((price/9)*3)} Down Payment`
    }
    else if(sr===4 || sr==="4" || sr==="9by3"){
        return `6 Month Low Cost EMIs (Total Interest Payable ₹${Math.round(((((price-Math.ceil((price/8)*2))*15)/100)/12)*6)}) + ₹${Math.ceil((price/8)*2)} Down Payment`
    }else if(sr===5 || sr==="5" || sr==="9by0"){
        return `9 Month Low Cost EMIs (Total Interest Payable ₹${Math.round((((price*14.66667)/100)/12)*9)}) + ₹0 Down Payment`
    }else if(sr===6 || sr==="6" || sr==="12by0"){
        return `12 Month Low Cost EMIs (Total Interest Payable ₹${Math.round((((price*14.5)/100)/12)*12)}) + ₹0 Down Payment`
    }
}


// export const renderTenureStringInterest = (sr,price)=>{
//     if(sr===1){
//         return `3 Month Low Cost EMIs (Total Interest Payable ₹${Math.round((((price*16)/100)/12)*3)}) + ₹0 Down Payment`
//     }else if(sr===2){
//         return `6 Month Low Cost EMIs (Total Interest Payable ₹${Math.round((((price*15)/100)/12)*6)}) + ₹0 Down Payment`
//     }else if(sr===3){
//         return `6 Month Low Cost EMIs (Total Interest Payable ₹${Math.round((((price*15)/100)/12)*6)}) + ₹${Math.ceil((price/9)*3)} Down Payment`
//     }
//     else if(sr===4){
//         return `6 Month Low Cost EMIs (Total Interest Payable ₹${Math.round((((price*15)/100)/12)*6)}) + ₹${Math.ceil((price/8)*2)} Down Payment`
//     }
// }

export const renderInterestPercentage = (sr,price)=>{
    if(sr===1){
        return 4
    }else if(sr===2){
        return 7.50
    }else if(sr===3){
        return 5
    }
    else if(sr===4){
        return 5.63
    }else if(sr===5){
        return 11
    }else if(sr===6){
        return 14.5
    }
}

export const renderInterestAmount = (sr,price)=>{
    if(sr===1){
        return Math.round((price/100)*4)
    }else if(sr===2){
        return Math.round((price/100)*7.50)
    }else if(sr===3){
        return Math.round((price/100)*5)
    }
    else if(sr===4){
        return Math.round((price/100)*5.63)
    }
    else if(sr===5){
        return Math.round((price/100)*11)
    }
    else if(sr===6){
        return Math.round((price/100)*14.5)
    }
}